var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M-6.5188e-07 4.00451C-6.47703e-07 3.90895 0.0159968 3.81937 0.0479916 3.73576C0.0794791 3.65214 0.133312 3.5745 0.209491 3.50283L3.73276 0.188191C3.87242 0.0567994 4.04713 -0.00579071 4.25687 0.000420519C4.46611 0.00615397 4.64056 0.0747161 4.78022 0.206107C4.91988 0.337499 4.98971 0.504724 4.98971 0.707783C4.98971 0.910843 4.91988 1.07807 4.78022 1.20946L1.80925 4.00451L4.79927 6.81748C4.93893 6.94887 5.00571 7.11323 4.99962 7.31055C4.99302 7.5074 4.91988 7.67152 4.78022 7.80291C4.64056 7.9343 4.46281 8 4.24697 8C4.03113 8 3.85338 7.9343 3.71372 7.80291L0.209491 4.50619C0.133312 4.43452 0.079479 4.35688 0.0479916 4.27327C0.0159967 4.18965 -6.56057e-07 4.10007 -6.5188e-07 4.00451Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseLeft);
export default __webpack_public_path__ + "static/media/collapse_left.73b79583a8b522f5e31138751c1baa56.svg";
export { ForwardRef as ReactComponent };